import Validator from 'validatorjs';
import { allFieldsValidationCommon, customErrorMessagesCommon } from "../Validation";
import { QUOTE_QUESTIONS, MILEAGE_QUESTIONS } from "../../AppConstants";
import appStore from '../../state/store';

const VALIDATION = {
    INVALID_GARAGING_STATE: "Your car must be garaged in the state where you live",
    INVALID_INPUT_MILAGE: "Cannot be lower than the selected default value"
};

Validator.register('valid_garaging_state', function (value) {
    var mainStateCode = appStore.getState().stateCode;
    return mainStateCode === value;
});

Validator.registerImplicit('valid_value_miles', function (this: any, value, requirement, attribute) {
    const vehicle = this.validator.input;

    let check = true;

    if (vehicle.vehicleUse === QUOTE_QUESTIONS.VEHICLE_USE.PERSONAL) {
        if (value < 2500) {
            check = false;
        }
    }
    else if (vehicle.vehicleUse === QUOTE_QUESTIONS.VEHICLE_USE.COMMUTING) {
        switch (vehicle.mileage) {
            case MILEAGE_QUESTIONS.MILEAGE.LESS_THAN_THREE:
                if (value < 6595) {
                    check = false;
                }
                break;
            case MILEAGE_QUESTIONS.MILEAGE.FIVE:
                if (value < 7595) {
                    check = false;
                }
                break;
            case MILEAGE_QUESTIONS.MILEAGE.TEN: ;
                if (value < 10095) {
                    check = false;
                }
                break;
            case MILEAGE_QUESTIONS.MILEAGE.TWENTY:
                if (value < 15095) {
                    check = false;
                }
                break;
        }
    }

    return check;
});

const rules = {
    vehicleUse: 'required',
    valueMiles: ['required', 'valid_value_miles'],
    mileage: 'required_if:vehicleUse,' + QUOTE_QUESTIONS.VEHICLE_USE.COMMUTING,
    parkAtHome: 'required',
    garagingAddress: {
        street: 'required_if:parkAtHome,No',
        city: 'required_if:parkAtHome,No',
        zipCode: 'required_if:parkAtHome,No',
        stateCode:'valid_garaging_state'
    }
};

const customErrorMessages = {
    "valid_garaging_state": VALIDATION.INVALID_GARAGING_STATE,
    "valid_value_miles": VALIDATION.INVALID_INPUT_MILAGE,
};

export const allFieldsValidation = (data) => {
    return allFieldsValidationCommon(data, rules, { ...customErrorMessagesCommon, ...customErrorMessages });
};